import { FETCH_STUDIO_APP_CONF_HAS_ERRORED, FETCH_STUDIO_APP_CONF_IS_LOADING, FETCH_STUDIO_APP_CONF_SUCCESS } from '../actions/actionTypes';

import Constants from '../Constants';

const initialStudioAppConfigState = {
  cdnPrefix: Constants.CDN_PREFIX,
  currentToken: {},
  partners: [],
  partnerMetas: [],
  publishers: [],
  categories: [],
  experiments: [],
  cities: [],
  segments: [],
  glanceLanguages: [],
  sqlSegments: [],
  segmentTargetingRule: [],
  apps: [],
  bubbles: [],
  carrierMetas: [],
}
export function studioAppConfig(state = initialStudioAppConfigState, action) {
  switch (action.type) {
    case FETCH_STUDIO_APP_CONF_SUCCESS:
        return action.studioAppConfig;
    case FETCH_STUDIO_APP_CONF_IS_LOADING:
    case FETCH_STUDIO_APP_CONF_HAS_ERRORED:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/draftsReducer.ts